// extracted by mini-css-extract-plugin
export default {"modalBody":"omi0yMZ4Gp4X6mUbCJ6H"};